import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/brthrsagency.webp';
import screenshot_target from '../../../images/letterfunnel/janwillemdebirk.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Jan Willem de Birk"
      firstname="Jan"
      companyname="Brthrs Agency"
      competition="Level Level en Label A"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/janwillemdebirk.js